import React, { useRef } from "react";
import emblem from "../../Assets/icons/Emblem_of_India.png";
import rcFrontBg from "../../Assets/images/rc-front-bg.jpg";
import rcBackBg from "../../Assets/images/rc-back-bg.jpg";
import { getStateFromVehicleNumber } from "../../Utils/helpers";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";
import StateTriangle from "./StateTriangle";
import DLVehicleClassTable from "./DlVehicleClassTable";

export default function DLCardLayout({ dlData }) {
  const cardRef = useRef();

  return (
    <div ref={cardRef} className="flex gap-4 items-start">
      {/* Card to convert */}
      <div
        id="rc-card"
        className="mx-auto text-gray-900 font-sans relative overflow-hidden bg-contain bg-center bg-no-repeat w-[540px] h-[337px]"
        style={{ backgroundImage: `url(${rcFrontBg})` }}
      >
        {/* Header */}
        <div className="flex items-start justify-between px-6 py-4">
          <div>
            <div className="flex items-start">
              <img src={emblem} alt="Emblem of India" className="h-[70px]" />
              <div className="ml-10 pb-2">
                <h2 className="font-semibold text-[0.75rem] block">
                  INDIAN UNION DRIVING LICENCE
                </h2>
                <p className="text-[0.75rem] text-gray-700">
                  Issued by{" "}
                  <span className="font-semibold uppercase">
                    GOVERNMENT OF{" "}
                    {String(dlData?.rto_details?.state).toLocaleUpperCase()}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-start space-x-2">
            <div className="w-8 h-8 pb-4 rounded-full bg-orange-400 flex items-center justify-center text-black font-bold text-[0.75rem] border border-black">
              {dlData?.dlNumber
                ? String(dlData?.dlNumber).substring(0, 2).toUpperCase()
                : "NA"}
            </div>
          </div>
        </div>

        {/* Body */}

        <div className="flex flex-col items-start p-4 gap-2 -mt-8 relative">
          <div className="pb-4 pr-3 flex gap-[0.05rem] items-center w-full relative">
            <div className="w-[120px] mr-3 block"></div>
            <div className="flex flex-col gap-2 items-start w-full">
              <p>
                <span className="text-[0.75rem] block font-bold">
                  {dlData?.dlNumber ? dlData?.dlNumber : "NA"}
                </span>
              </p>
              <div className="flex gap-4 items-start w-full">
                <p>
                  <span className="block text-[0.75rem] -mb-1">Issue Date</span>
                  <span className="text-[0.75rem] block font-semibold">
                    {dlData?.validity?.non_transport?.issue_date
                      ? dlData?.validity?.non_transport?.issue_date
                      : "NA"}
                  </span>
                </p>
                <p>
                  <span className="block text-[0.75rem] -mb-1">
                    Validity (NT)
                  </span>
                  <span className="text-[0.75rem] block font-semibold">
                    {dlData?.validity?.non_transport?.expiry_date
                      ? dlData?.validity?.non_transport?.expiry_date
                      : "NA"}
                  </span>
                </p>
                <p>
                  <span className="block text-[0.75rem] -mb-1">
                    Validity (TR)
                  </span>
                  <span className="text-[0.75rem] block font-semibold">
                    {dlData?.validity?.transport?.expiry_date
                      ? dlData?.validity?.transport?.expiry_date
                      : "NA"}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 w-[150px]">
              <img
                src={`data:image/png;base64,${dlData?.photo_base64}`}
                className="w-20 ml-4 pr-2"
              />
            </div>
          </div>
          <div className="flex gap-0 flex-col">
            <p>
              <span className="text-[0.75rem] -mb-1">Name : </span>
              <span className="text-[0.75rem] font-semibold">
                {dlData?.name ? dlData?.name : "NA"}
              </span>
            </p>
            <div className="flex gap-4 items-start w-full">
              <p>
                <span className="text-[0.75rem] -mb-1">Date Of Birth : </span>
                <span className="text-[0.75rem] font-semibold">
                  {dlData?.date_of_birth ? dlData?.date_of_birth : "NA"}
                </span>
              </p>
              <p>
                <span className="text-[0.75rem] -mb-1">Blood Group: </span>
                <span className="text-[0.75rem] font-semibold">
                  {dlData?.blood_group ? dlData?.blood_group : "NA"}
                </span>
              </p>
              <p>
                <span className="text-[0.75rem] -mb-1">Organ Donar: </span>
                <span className="text-[0.75rem] font-semibold">
                  {dlData?.organ_donar ? dlData?.organ_donar : ""}
                </span>
              </p>
            </div>
            <p>
              <span className="text-[0.75rem] -mb-1">
                Son/Daughter/Wife of :{" "}
              </span>
              <span className="text-[0.75rem] font-semibold">
                {dlData?.dependent_name ? dlData?.dependent_name : "NA"}
              </span>
            </p>
            <p>
              <span className="text-[0.75rem] -mb-1">Address: </span>
              <span className="text-[0.75rem] font-semibold">
                {dlData?.address ? dlData?.address : "NA"}
              </span>
            </p>
          </div>
          <p className="absolute -right-[60px] bottom-[40%] text-[0.65rem] -rotate-90">
            Date of First Issue {"("}
            {dlData?.validity?.non_transport?.issue_date
              ? dlData?.validity?.non_transport?.issue_date
              : "N/A"}
            {")"}
          </p>
        </div>
      </div>
      <div
        id="rc-card"
        className="mx-auto text-gray-900 font-sans relative overflow-hidden bg-contain bg-center bg-no-repeat w-[540px] h-[337px]"
        style={{ backgroundImage: `url(${rcBackBg})` }}
      >
        {/* Header */}
        <div className="flex items-start justify-start px-6 py-4">
          <div className="flex items-center h-10">
            <div className="ml-10">
              <p className="text-[0.75rem]">
                <span className="font-semibold">DL NO.: </span>
                <span className="uppercase">
                  {dlData?.dlNumber ? dlData?.dlNumber : "N/A"}
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Body */}

        <div className="flex items-end p-4 gap-6 -mt-6">
          <div className="pb-4 flex flex-col gap-[0.05rem] w-full relative">
            <div className="pb-4 pr-3 flex gap-[0.05rem] items-start w-full relative -mb-2">
              <div className="w-[100px] mr-3 block">
                <QRCodeCanvas
                  size={80}
                  value="https://sarathi.parivahan.gov.in/sarathiservice/rsServices/sarathi/QRService/DLDetails/dlqrresult"
                />
              </div>
              <div className="flex flex-col gap-4 items-start w-full">
                <p>
                  <span className="block text-[0.75rem] -mb-1">
                    ADPVEH No.(Regn.Numbers)
                  </span>
                  <span className="text-[0.75rem] font-semibold">
                    {dlData?.ad
                      ? moment(
                          new Date(dlData?.validity?.hazardous?.expiry_date)
                        ).format("DD-MM-YYYY")
                      : ""}
                  </span>
                </p>
                <div className="flex gap-4 justify-between items-start w-full">
                  <p>
                    <span className="text-[0.75rem] -mb-1">
                      Hazardous validity
                    </span>
                    <span className="text-[0.75rem] font-semibold">
                      {dlData?.validity?.hazardous?.expiry_date
                        ? moment(
                            new Date(dlData?.validity?.hazardous?.expiry_date)
                          ).format("DD-MM-YYYY")
                        : ""}
                    </span>
                  </p>
                  <p className="w-[40%]">
                    <span className="text-[0.75rem] -mb-1">Hill Validity </span>
                    <span className="text-[0.75rem] font-semibold">
                      {dlData?.validity?.hill?.expiry_date
                        ? moment(
                            new Date(dlData?.validity?.hill?.expiry_date)
                          ).format("DD-MM-YYYY")
                        : ""}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <DLVehicleClassTable driving_license_data={dlData} />
            <div className="flex gap-4 justify-between items-start w-full">
              <p>
                <span className="text-[0.75rem] -mb-1">Mobile Number: </span>
                <span className="text-[0.75rem]">
                  {dlData?.mobile_number ? dlData?.mobile_number : ""}
                </span>
              </p>
              <p className="w-1/2 text-center">
                <span className="block text-[0.75rem] -mb-1">
                  Licencing Authority{" "}
                </span>
                <span className="text-[0.75rem]">
                  {dlData?.rto_details?.authority
                    ? dlData?.rto_details?.authority
                    : "NA"}
                </span>
              </p>
            </div>
            <p className="text-[0.50rem] text-center">
              This duplicate card, generated from publicly available data on
              sarathi.parivahan.gov.in, is for reference/personal use only.
            </p>
            <p className="absolute -right-[35px] bottom-[60%] text-[0.45rem] -rotate-90 font-bold">
              Form 7 Rule 16 (2)
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
